// @flow


import React from 'react';
import type {StatelessFunctionalComponent} from 'react';

/**
 * Body component Props
 */
type BodyProps = {|
    children: React$Node,
    id?: string,
    onMouseEnter?: () => void,
    onMouseLeave?: () => void,
|};

export const Body: StatelessFunctionalComponent<BodyProps> = props => {
    return (
        <tbody {...{
            ...(props.id ? {id: props.id} : null),
            onMouseEnter: props.onMouseEnter,
            onMouseLeave: props.onMouseLeave
        }}>{props.children}</tbody>
    );
};
